export default {
  ENVIRONMENT_NAME: 'prd',
  REGION: 'us-west-2',
  USER_POOL_ID: 'us-west-2_me5asDSTP',
  USER_POOL_APP_CLIENT_ID: '46b0d84jla534nd79m51egabgd',
  ENDPOINT_ADMIN: 'https://kstmsrg3tk.execute-api.us-west-2.amazonaws.com/prod',
  ENDPOINT_THUMBNAIL: 'https://d21s539280g9dt.cloudfront.net/sa-east-1',
  GRAPHQL_URL:
    'https://gqnc2frow5ajxdbgdrsrqnvp3q.appsync-api.us-west-2.amazonaws.com/graphql',
  API_KEY: '',
  ENDPOINT_PLAYER_WEB: 'https://video-player-web.sesc.digital',
};
